(function() {
  'use strict';

  /* ── Scroll animations via IntersectionObserver ── */
  var selectors = [
    '.section-header', 'h2.section-header__title',
    '[class*="section-header"]', '.title-wrapper',
    '.image-with-text h2', '.rich-text .heading',
    '.bmd-animate', '.bmd-separator'
  ].join(',');

  var animElements = document.querySelectorAll(selectors);

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('bmd-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    animElements.forEach(function(el) { observer.observe(el); });
  } else {
    animElements.forEach(function(el) { el.classList.add('bmd-in-view'); });
  }

  /* ── Header shrink on scroll ── */
  var header = document.querySelector('.header-wrapper');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 50) {
        header.classList.add('bmd-scrolled');
      } else {
        header.classList.remove('bmd-scrolled');
      }
    }, { passive: true });
  }

  /* ── Cart bounce op add-to-cart ── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[name="add"], .product-form__submit, [data-add-to-cart]');
    if (btn) {
      setTimeout(function() {
        var cartIcon = document.querySelector('.header__icon--cart, [class*="cart-icon"]');
        if (cartIcon) {
          cartIcon.classList.add('bmd-cart-added');
          setTimeout(function() {
            cartIcon.classList.remove('bmd-cart-added');
          }, 600);
        }
      }, 300);
    }
  });
})();
